import { makeVar } from '@apollo/client'

export const dateRangeDropDownQueryParamsVar = makeVar('')
